import { z } from 'zod';
import { ReportFormatSchema, ReportStatusSchema, ReportTypeSchema } from './enums';
import { IdSchema } from './validation';

export const GenerateReportSchema = z
  .object({
    type: ReportTypeSchema,
    academicYearId: IdSchema,
    termId: IdSchema.optional(),
    classId: IdSchema.optional(),
    studentId: IdSchema.optional(),
    format: ReportFormatSchema,
    /** Quando true, a narrativa é gerada com IA (dados anonimizados). */
    useAi: z.boolean().default(true),
  })
  .superRefine((value, ctx) => {
    if (value.type === 'CLASS_PERFORMANCE' && !value.classId) {
      ctx.addIssue({ code: 'custom', path: ['classId'], message: 'Selecione uma turma' });
    }
    if (value.type === 'STUDENT_TRANSCRIPT' && !value.classId && !value.studentId) {
      ctx.addIssue({
        code: 'custom',
        path: ['classId'],
        message: 'Selecione uma turma ou aluno para o boletim',
      });
    }
  });
export type GenerateReportInput = z.input<typeof GenerateReportSchema>;
export type GenerateReportData = z.output<typeof GenerateReportSchema>;

export const ListReportsQuerySchema = z.object({
  status: ReportStatusSchema.optional(),
  cursor: z.string().max(200).optional(),
  limit: z.coerce.number().int().min(1).max(50).default(20),
});
export type ListReportsQuery = z.input<typeof ListReportsQuerySchema>;

export const ReportSchema = z.object({
  id: z.string(),
  type: ReportTypeSchema,
  title: z.string(),
  academicYearId: z.string().nullable(),
  termId: z.string().nullable(),
  classId: z.string().nullable(),
  format: ReportFormatSchema,
  status: ReportStatusSchema,
  errorMessage: z.string().nullable(),
  usedAi: z.boolean(),
  generatedBy: z.string(),
  createdAt: z.string(),
  completedAt: z.string().nullable(),
});
export type Report = z.infer<typeof ReportSchema>;
